import request from './request.js';

// 首页-轮播图
export function getLbtList(params) {
	return request({
		url: '/open/page',
		method: 'get',
		params,
	})
}
// 新闻类
export function getXwList(params) {
	return request({
		url: '/open/getSimpleContentListPageByColumnId',
		method: 'get',
		params,
	})
}
// 新闻类详情
export function getXwDetails(id) {
	return request({
		url: '/open/getOwContentById/'+id,
		method: 'get',
	})
}
// 简单类
export function getSimpleList(params) {
	return request({
		url: '/open/getAllOwGridContentById/'+ params.contentType,
		method: 'get',
	})
}
// 农产品类
export function getProductsList(params) {
	return request({
		url: '/open/getOwQuotationPage',
		method: 'get',
		params,
	})
}
// 宣传视频
export function getVideo() {
	return request({
		url: '/open/getVideo',
		method: 'get',
	})
}
// 招聘信息
export function getRecruitmentList(params) {
	return request({
		url: '/open/getOwRecruitmentPage',
		method: 'get',
		params,
	})
}
// 股票信息
export function getTock(params) {
	return request({
		// url: 'https://tsanghi.com/api/fin/stock/XSHG/realtime?token=demo&ticker=601519',
		url: 'https://qt.gtimg.cn/q=sh600113',
		method: 'get',
		params,
	})
}
// 搜索
export function getOwContentByKey(params) {
	return request({
		url: '/open/getOwContentByKey',
		method: 'get',
		params,
	})
}